export default function ApproachSection() {
  const principles = [
    {
      icon: 'ri-stack-line',
      title: 'Clean Architecture',
      description: 'Every system is built on well-defined architectural boundaries with clear separation of concerns, ensuring maintainability and adaptability as requirements evolve.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Performance Optimization',
      description: 'Relentless focus on runtime efficiency, memory management, and responsive interfaces that deliver smooth, fast experiences across all scenarios.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'User-Centered Design',
      description: 'Engineering decisions are guided by how real users interact with software, prioritizing intuitive interfaces, accessibility, and meaningful workflows.',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Continuous Innovation',
      description: 'Actively exploring emerging technologies and evolving internal processes to stay at the forefront of modern software engineering practices.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Stability & Reliability',
      description: 'Building systems that perform consistently under real-world conditions with robust error handling, thorough testing, and defensive coding practices.',
    },
    {
      icon: 'ri-loop-right-line',
      title: 'Iterative Improvement',
      description: 'Refining development workflows through regular retrospectives, adopting up-to-date engineering standards, and measuring outcomes to drive meaningful progress.',
    },
  ];

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="max-w-[640px] mb-14 md:mb-18">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-950 leading-[1.2] tracking-tight">
            How We Build Software
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-500 leading-relaxed">
            Our engineering approach combines modern methodologies with pragmatic decision-making to deliver solutions that stand the test of time.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {principles.map((p, i) => (
            <div key={i} className="flex gap-4 p-5 rounded-lg bg-background-100 border border-secondary-200/40">
              <span className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-md bg-accent-100 text-accent-600" aria-hidden="true">
                <i className={`${p.icon} text-lg`}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5">
                  {p.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {p.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}